// Port of api/fuel/app/classes/filter/search/games/rules/query/artists.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'artists',
	isIndex: function() { return 'artist' }
})
